import axios from "axios";
import myApp from "../main";

const service = axios.create({
  timeout: 60000 // 请求超时时间
});
let baseUrl = "";
service.interceptors.request.use(
  config => {
    myApp.$store.commit("addRemoteDataLoading");
    return config;
  },
  error => {
    myApp.$store.commit("reduceRemoteDataLoading");
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  response => {
    myApp.$store.commit("reduceRemoteDataLoading");
    return response;
  },
  error => {
    myApp.$store.commit("reduceRemoteDataLoading");
    return Promise.reject(error);
  }
);

//console.log("service.defaults.headers.token", service.defaults.headers.token);

export default {
  install(Vue, options) {
    baseUrl = options.baseUrl;
    Vue.prototype.$axios = $axios;
    // Vue.prototype.$setToken = setToken;
    Vue.prototype.$download = $download;
  }
};
export function $axios(url, options = {}) {
  let token = "";
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    token = JSON.parse(userInfo).token;
  }

  const finalOptions = Object.assign(
    {},
    {
      headers: {
        "Content-Type": "application/json",
        token: token
      },
      credentials: "include",
      url: `${baseUrl}${url}`,
      method: "post"
    },
    options
  );
  return new Promise((resolve, reject) => {
    service(finalOptions)
      .then(res => {
        const data = res.data;
        if (data.code != 0) {
          myApp.$notify({
            title: "警告",
            message: "错误原因：" + data.msg,
            type: "error"
          });
          // if (data.code === 1000) {
          //   myApp.$alert(data.msg, "提示", {
          //     confirmButtonText: "确定",
          //     callback: () => {
          //       myApp.$router.replace({
          //         name: "login"
          //       });
          //       return;
          //     }
          //   });
          // }

          if (data.code === 1000) {
            console.log("token失效，跳转到login页面");
            // 公开页面无需登录，不跳转
            if (myApp.$route.name !== "notifyMessagePublic") {
              myApp.$router.replace({
                name: "login"
              });
            }
            return;
          }

          reject(data);
        } else {
          resolve(data.result);
        }
      })
      .catch(error => {
        myApp.$notify({
          title: "警告",
          message: error,
          type: "error"
        });
        reject(error);
      });
  });
}

export function $download(url, options = {}) {
  let token = "";
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    token = JSON.parse(userInfo).token;
  }
  const finalOptions = Object.assign(
    {},
    {
      headers: {
        token: token
      },
      credentials: "include",
      url: `${baseUrl}${url}`,
      method: "post",
      responseType: "blob"
    },
    options
  );
  return new Promise((resolve, reject) => {
    service(finalOptions)
      .then(res => {
        console.log(res);
        resolve(res);
      })
      .catch(error => {
        myApp.$notify({
          title: "警告",
          message: error,
          type: "error"
        });
        reject(error);
      });
  });
}

// eslint-disable-next-line no-unused-vars
// function setToken(token, data) {
//   service.defaults.headers.token = token;
//   //window.sessionStorage.setItem("token", token);
// }
